import * as React from "react";
import styled from "styled-components";

import Nav from "../Nav";

const TOP_HEIGHT = 60;

const Base = styled.div`
  width: 100vw;
  height: 100vh;
`;

const Top = styled.div`
  height: ${TOP_HEIGHT}px;
`;

const Body = styled.div`
  height: calc(100% - ${TOP_HEIGHT}px);
  padding: 32px 24px 0px;
  box-sizing: border-box;
`;

type Props = {
  children: any;
  bodyStyle?: React.CSSProperties;
};

function Layout({ children, bodyStyle }: Props) {
  return (
    <Base>
      <Top>
        <Nav />
      </Top>
      <Body style={bodyStyle}>{children}</Body>
    </Base>
  );
}

export default Layout;
